import GroupBranchRuleTable from "./groupBranchRuleTable.container";

export default GroupBranchRuleTable;
